<template>
  <div class="renewal__modal" ref="renewalModal" tabindex="0" @keydown.esc="close">
    <div class="renewal__modal__backdrop" @click="close"></div>
    <div class="renewal__modal__content">
      <img :src="require(`@/assets/svg/Icon-Alert.svg`)" alt="Modal icon">

      <h2>{{ data.title }}</h2>

      <div class="renewal__modal__content__body" v-html="data.body" />

      <button type="button" @click.prevent.stop="go">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RenewalModal',
  props: {
    type: {
      type: String,
      required: true,
      validator: function (value) {
        return ['renew', 'change'].indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      contentList: {
        renew: {
          title: 'Apólice vencida',
          body: '<p>Devido ao vencimento a renovação contará novamente com um período de carência de 30 dias.</p>'
        },
        change: {
          title: 'Troca de aparelho',
          body: '<p>Se você efetuou a troca de aparelho é necessário contratar um novo seguro.</p><p>Lembre-se de cancelar o seguro de seu aparelho antigo através da nossa central de atendimento.</p>'
        }
      }
    }
  },
  computed: {
    data () {
      return this.contentList[this.type]
    }
  },
  created () {
    const body = document.getElementsByTagName('body')[0]
    body.setAttribute('aria-hidden', 'true')
  },
  mounted () {
    this.$refs.renewalModal.focus()
  },
  beforeDestroy () {
    const body = document.getElementsByTagName('body')[0]
    body.setAttribute('aria-hidden', 'false')
  },
  methods: {
    go () {
      sessionStorage.setItem('coupon', 'RENOVASITE')
      return this.$router.push('/')
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.renewal__modal {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 999;

  &__backdrop {
    background: rgba(0, 0, 0, 0.4);
    height: 100%;
    position: absolute;
    width: 100%;
  }

  &__content {
    align-items: center;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    max-width: 750px;
    padding: 75px 0;
    position: relative;
    width: 90%;

    h2 {
      margin: 24px 0 16px;
    }

    &__body {
      color: #707070;
      font-size: 16px;
      margin-bottom: 16px;
      max-width: 400px;
      text-align: center;
      width: 90%;
    }

    button {
      border: 1px solid #C8C8C8;
      border-radius: 28px;
      color: #444444;
      font-family: Oscine, sans-serif;
      font-size: 20px;
      font-weight: 600;
      line-height: 26px;
      padding: 16px 48px;
      transition: filter 0.2s;

      &:hover {
        filter: brightness(0.7);
      }

      &:focus {
        box-shadow: 0 0 0 0.2rem #fff, 0 0 0 0.35rem #069;
        outline: 0;
      }
    }
  }
}
</style>
